import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { useQueryDownloader } from '@trinity/chat-components/containers/QueryDownloader/hooks';

type Params = {
  chatInstanceId: number;
  name: string;
};

export const useDownloadChatInstance = (params: Params) => {

  const apiClient = useChatApiClient();

  return useQueryDownloader({
    queryKey: [
      `brand-insights:chat:download`,
      params.chatInstanceId,
    ],
    queryFn: ({ queryKey: [, chatInstanceId] }) => {
      return apiClient.chatInstances.downloadChatInstance({ chatInstanceId });
    },
    meta: {
      downloader: true,
    },
    downloaderOptions: {
      onResponse: res => ({
        filename: `${params.name}.docx`,
        type: 'blob',
        value: res.data,
      }),
    },
  });

};